/* stylelint-disable selector-type-no-unknown */

import styled, { css } from 'styled-components';

import * as mx from 'core/styles/mixins';
import * as vr from 'core/styles/variables';
import { Label } from 'pods/forms/components/base/Label/Label.style';

export const ErrorMessage = styled.div`
	left: 0;
	color: ${vr.formfieldErrorColor};
	font-size: ${vr.formfieldErrorMessageFontSize};
	display: flex;
	margin-top: 5px;

	& > i {
		margin-right: 4px;
		flex-shrink: 0;
	}

	/* This gives the error message container some invisible content when the
	error message un-renders, making for a smoother closing animation of <Collapse/> */
	&::after {
		content: '-';
		font-size: inherit;
		color: transparent;
	}
`;

export const HelpText = styled.span`
	margin-top: 12px;
	font-size: ${vr.formfieldHelpTextFontSize};
	display: block;
`;

export const LabelContents = styled.div``;

export const FieldContents = styled.div<{
	fullWidth?: boolean;
	customClassName?: string;
}>`
	width: 100%;
	padding: 0;
	position: relative;

	${({ fullWidth }) =>
		!fullWidth &&
		css`
			max-width: 400px;
		`}

	&:focus-within > .rah-static {
		display: none;
	}

	${({ customClassName }) =>
		!!customClassName &&
		css`
			margin: -30px 0 40px 0;
		`}
`;

export const Field = styled.div<{
	hasAppendMsg: boolean;
	ctrlHolderFullWidth: boolean;
	startAdornment?: string;
	endAdornment?: string;
	hasError?: boolean;
	enableButtonWithin?: boolean;
}>`
	position: relative;

	${({ hasAppendMsg, ctrlHolderFullWidth }) =>
		!!hasAppendMsg &&
		css`
			margin: 0 0 20px;

			${mx.bp('s')`
				width: ${ctrlHolderFullWidth ? '100%' : '200px'};
				margin: 0 30px 0 0;
				display: inline-block;
			`}
		`}

		${({ startAdornment, hasError }) =>
			!!startAdornment &&
			css`
			&::before {
				position: absolute;
				content: '${startAdornment}';
				top: 13px;
				left: 16px;
				bottom: 0;
				color: ${hasError ? vr.formfieldErrorColor : vr.formfieldPlaceholderColor};
			}
		`}

	${({ endAdornment, hasError }) =>
		!!endAdornment &&
		css`
			&::after {
				position: absolute;
				content: '${endAdornment}';
				top: 13px;
				right: 16px;
				bottom: 0;
				color: ${hasError ? vr.formfieldErrorColor : vr.formfieldPlaceholderColor};
			}
		`}

	&:focus-within {
		${({ enableButtonWithin }) =>
			enableButtonWithin &&
			css`
				input {
					padding-right: 38px;
				}
			`}

		.text-button-within {
			visibility: visible;
		}
	}
`;

export const CtrlHolder = styled.div<{
	hasError: boolean;
	margin?: string;
}>`
	position: relative;
	display: flex;
	flex-direction: column;
	margin-top: ${vr.formCtrlHolderSpacing};

	${({ hasError }) =>
		hasError &&
		css`
			${Label} {
				color: ${vr.formfieldErrorColor};
			}
		`}

	${({ margin }) =>
		margin &&
		css`
			margin: ${margin};
		`}
`;

export const BottomMessage = styled.div`
	margin-top: 8px;
	font-size: ${vr.formfieldHelpTextFontSize};
	color: ${vr.formfieldLabelOptionalColor};
`;

export const LegendLabel = styled.label<{
	hasValue: boolean;
	disabled: boolean | undefined;
	hasError: boolean;
}>`
	position: absolute;
	top: -10px;
	left: 10px;
	background-color: ${vr.brandWhite};

	font-size: 12px;
	border-radius: 4px;
	padding: 1px 4px;
	display: ${({ hasValue }) => (hasValue ? `block` : `none`)};
	color: ${({ hasError }) =>
		hasError ? vr.formfieldErrorColor : vr.formfieldOnHoverBorderColor};

	> div, p {
		font-size: 12px;
	}

	${Field}:hover + & {
		display: ${({ disabled, hasValue, hasError }) =>
			disabled || (!hasValue && hasError) ? `none` : `block`};
	}

	${Field}:focus-within + &,
	${Field}:active + & {
		color: ${({ hasError }) =>
			hasError ? vr.formfieldOnHoverBorderColor : vr.formfieldBorderColorFocus};
		display: block;
	}
`;

export const BottomMessageContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;

	> i {
		margin-top: 4px;
	}
`;
